import { Space } from 'antd';
import styled from 'styled-components';

export const StyledStatusLabel = styled(Space)<{ $color: string }>`
    color: ${({ $color }) => $color};
`;
